import React, { Component } from "react";

import GridPanel from "./History/GridPanel";
import HistoryDetailPanel from "./History/HistoryDetailPanel";

export default class HistoryPanel extends Component
{
    constructor(props)
    {
        super(props);
        this.state =
        {
            receiptHistoryData: null,
            currentReceipt: null,
            lastReceipt: null
        }

        this.onReceiptRowSelectChange = this.onReceiptRowSelectChange.bind(this);

        //this.syncBatch = this.syncBatch.bind(this);
        //this.onSyncCompleteEvent = this.onSyncCompleteEvent.bind(this);
    }

    async componentDidMount()
    {
        //if (this.props.isConnected) {
         // this.syncTimer = setInterval(() => this.syncBatch(), 10000);
        //}
    }

    onReceiptRowSelectChange(newReceipt)
    {
        this.setState({currentReceipt: newReceipt});
        if (newReceipt) this.setState({lastReceipt: newReceipt}); // only update if it's not null. In other words, only if the USER selected to change it so we can still see logs and menu choices.
    }

  
 

    render() 
    {

        console.log("Obs@HistoryPanel");
        //console.info(this.props.selectedReceiptRow);

        return(
            <div id="history">


                <GridPanel
                    userSession={this.props.userSession}
                    userSessionKey={this.props.userSessionKey}
                    onlineInfo={this.props.onlineInfo}
                    currentReceipt={this.state.currentReceipt}
                    lastReceipt={this.state.logReceipt}
                    onErrorPageRequest={this.props.onErrorPageRequest}
                    gridQueryString={this.state.gridQueryString}
                    onUpdateCurrentReceipt = {this.onReceiptRowSelectChange}
                    onQuarantinePageRequest = {this.props.onQuarantinePageRequest}
                    onAddReceiptPageRequest = {this.props.onAddReceiptPageRequest}
                    onPrintTagTestRequest = {this.props.onPrintTagTestRequest}
                    onRefreshUserSessionKey = {this.props.onRefreshUserSessionKey}
                />
                <HistoryDetailPanel
                    currentReceipt={this.state.lastReceipt}
                />

            </div>

        )
    }
}